msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/admin/pages/DashboardPage.tsx
msgid "(empty — v0 orphan)"
msgstr "（空值 — v0 遗留记录）"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "(empty)"
msgstr "（空）"

#. placeholder {0}: formatNumber(i18n, snap.p50_ms)
#. placeholder {0}: formatNumber(i18n, snap.p95_ms)
#. placeholder {0}: formatNumber(i18n, snap.p99_ms)
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "{0} ms"
msgstr "{0} 毫秒"

#: src/admin/pages/UserDetailPage.tsx
msgid "{disabledAgentCount, plural, one {# agent is disabled.} other {# agents are disabled.}} Enabling this account does not enable them — open each agent to enable it."
msgstr "{disabledAgentCount, plural, one {# 个 Agent 已禁用。} other {# 个 Agent 已禁用。}}启用此账号不会自动启用这些 Agent，请打开各自的页面单独启用。"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "⚠️ Above threshold"
msgstr "⚠️ 超出阈值"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "✅ Normal"
msgstr "✅ 正常"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Account"
msgstr "账号"

#: src/admin/pages/UserDetailPage.tsx
msgid "Account disabled"
msgstr "账号已禁用"

#: src/admin/pages/UserDetailPage.tsx
msgid "Account enabled"
msgstr "账号已启用"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Actions"
msgstr "操作"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Active"
msgstr "正常"

#: src/admin/pages/DashboardPage.tsx
msgid "Admin-only visibility. Not exposed to end-users."
msgstr "仅管理员可见，不向终端用户展示。"

#: src/admin/messages.ts
msgid "Agent"
msgstr "Agent"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent disabled"
msgstr "Agent 已禁用"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent enabled"
msgstr "Agent 已启用"

#: src/admin/pages/RuntimesPage.tsx
msgid "Agent ID"
msgstr "Agent ID"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent not found"
msgstr "找不到 Agent"

#. placeholder {0}: formatNumber(i18n, agents.length)
#: src/admin/pages/UserDetailPage.tsx
msgid "Agents ({0})"
msgstr "Agent（{0}）"

#. placeholder {0}: owner.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "An agent can only be active while its owner is. Enable <0>{0}</0> first, then enable this agent here."
msgstr "Agent 只有在所有者账号正常时才能启用。请先启用 <0>{0}</0>，再回到这里启用此 Agent。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "API Key"
msgstr "API 密钥"

#: src/admin/pages/SettingsPage.tsx
msgid "API Prefix"
msgstr "API 前缀"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Archived At"
msgstr "归档时间"

#: src/admin/AdminApp.tsx
msgid "Archived Channels"
msgstr "已归档频道"

#. placeholder {0}: formatNumber(i18n, channels.length)
#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Archived Channels ({0})"
msgstr "已归档频道（{0}）"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Back"
msgstr "返回"

#: src/admin/AdminApp.tsx
#: src/admin/pages/LoginPage.tsx
msgid "Borgee Admin"
msgstr "Borgee 管理后台"

#: src/admin/confirm.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Cancel"
msgstr "取消"

#. placeholder {0}: formatNumber(i18n, permissions.length)
#: src/admin/pages/AgentDetailPage.tsx
msgid "Capabilities ({0})"
msgstr "权限（{0}）"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Capability"
msgstr "权限"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Changes"
msgstr "变更条数"

#: src/admin/messages.ts
msgid "Channel"
msgstr "频道"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Channel ID"
msgstr "频道 ID"

#: src/admin/AdminApp.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/DashboardPage.tsx
msgid "Channels"
msgstr "频道"

#. placeholder {0}: formatNumber(i18n, channels.length)
#: src/admin/pages/UserDetailPage.tsx
msgid "Channels ({0})"
msgstr "频道（{0}）"

#: src/admin/pages/InvitesPage.tsx
msgid "Code"
msgstr "邀请码"

#: src/admin/pages/UsersPage.tsx
msgid "Create"
msgstr "创建"

#: src/admin/pages/UsersPage.tsx
msgid "Create an account for <0>{displayName}</0> at <1>{email}</1>? They can sign in with the password entered here right away. The server also provisions around them: their own org, a personal Project holding <2>#general</2> and <3>#welcome</3> that they are joined to, a welcome post in it, and the unrestricted <4>(*, *)</4> capability grant every member gets."
msgstr "为 <0>{displayName}</0> 创建邮箱为 <1>{email}</1> 的账号？用户可以立即使用此处输入的密码登录。服务器还会创建专属组织和个人项目，让用户加入其中的 <2>#general</2> 与 <3>#welcome</3> 频道，发布欢迎消息，并授予每位成员均有的无限制 <4>(*, *)</4> 权限。"

#: src/admin/pages/UsersPage.tsx
msgid "Create User"
msgstr "创建用户"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Created"
msgstr "创建时间"

#: src/admin/AdminApp.tsx
#: src/admin/pages/DashboardPage.tsx
msgid "Dashboard"
msgstr "仪表盘"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Delete"
msgstr "删除"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Delete <0>{0}</0>? Their sessions end, their channel memberships are dropped, and every agent they own is deleted with them. Messages they already sent stay, still under their name. This console has no way back."
msgstr "删除 <0>{0}</0>？用户的会话将结束，频道成员关系将移除，其拥有的所有 Agent 也会一并删除。已发送的消息会保留，仍显示该用户的名字。此操作无法在管理后台恢复。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Delete Agent"
msgstr "删除 Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Delete agent <0>{0}</0>? Its API key and capability grants die with it, and a deleted agent can never be restored — bringing this one back means creating a new agent."
msgstr "删除 Agent <0>{0}</0>？其 API 密钥和权限将一并失效，已删除的 Agent 无法恢复。如需再次使用，必须创建新的 Agent。"

#: src/admin/pages/UserDetailPage.tsx
msgid "Delete User"
msgstr "删除用户"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Deleted"
msgstr "已删除"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Description History"
msgstr "描述历史"

#: src/admin/messages.ts
msgid "Direct Message"
msgstr "私信"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Disable"
msgstr "禁用"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Disable <0>{0}</0>? They lose access immediately, and every agent they own is disabled with them."
msgstr "禁用 <0>{0}</0>？用户将立即失去访问权限，其拥有的所有 Agent 也会一并禁用。"

#: src/admin/pages/UserDetailPage.tsx
msgid "Disable Account"
msgstr "禁用账号"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Disable Agent"
msgstr "禁用 Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Disable agent <0>{0}</0>? Its API key stops working at once and any live connection is dropped."
msgstr "禁用 Agent <0>{0}</0>？其 API 密钥将立即失效，所有现有连接都会断开。"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Disabled"
msgstr "已禁用"

#: src/admin/pages/UsersPage.tsx
msgid "Display Name"
msgstr "显示名称"

#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Email"
msgstr "邮箱"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Enable"
msgstr "启用"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Enable <0>{0}</0>? They regain access immediately. Agents they own stay disabled until each one is enabled on its own page."
msgstr "启用 <0>{0}</0>？用户将立即恢复访问权限。其拥有的 Agent 仍会保持禁用，需要在各自的页面中单独启用。"

#: src/admin/pages/UserDetailPage.tsx
msgid "Enable Account"
msgstr "启用账号"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Enable Agent"
msgstr "启用 Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Enable agent <0>{0}</0>? It can connect and act with its granted capabilities again."
msgstr "启用 Agent <0>{0}</0>？它将能够重新连接，并使用已获授的权限执行操作。"

#. placeholder {0}: session.login
#: src/admin/LogoutButton.tsx
msgid "End the admin session for <0>{0}</0>? Signing back in is required to reach the console again."
msgstr "结束 <0>{0}</0> 的管理员会话？再次访问管理后台时需要重新登录。"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Endpoint"
msgstr "端点"

#: src/admin/messages.ts
msgid "Error"
msgstr "错误"

#: src/admin/pages/InvitesPage.tsx
msgid "Expired"
msgstr "已过期"

#: src/admin/pages/InvitesPage.tsx
msgid "Expires"
msgstr "过期时间"

#: src/admin/pages/InvitesPage.tsx
msgid "Expires In Hours"
msgstr "有效期（小时）"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to create invite"
msgstr "创建邀请码失败"

#: src/admin/pages/UsersPage.tsx
msgid "Failed to create user"
msgstr "创建用户失败"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to delete agent"
msgstr "删除 Agent 失败"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to delete user"
msgstr "删除用户失败"

#: src/admin/pages/ChannelsPage.tsx
msgid "Failed to force delete channel"
msgstr "强制删除频道失败"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to grant capability"
msgstr "授予权限失败"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to load agent"
msgstr "加载 Agent 失败"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Failed to load archived channels"
msgstr "加载已归档频道失败"

#: src/admin/pages/ChannelsPage.tsx
msgid "Failed to load channels"
msgstr "加载频道失败"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Failed to load heartbeat lag"
msgstr "加载心跳滞后数据失败"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Failed to load history"
msgstr "加载历史失败"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to load invites"
msgstr "加载邀请码失败"

#: src/admin/pages/RuntimesPage.tsx
msgid "Failed to load runtimes"
msgstr "加载运行时失败"

#: src/admin/pages/DashboardPage.tsx
msgid "Failed to load stats"
msgstr "加载统计数据失败"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to load user"
msgstr "加载用户失败"

#: src/admin/pages/UsersPage.tsx
msgid "Failed to load users"
msgstr "加载用户列表失败"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to reset password"
msgstr "重置密码失败"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to revoke capability"
msgstr "撤销权限失败"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to revoke invite"
msgstr "撤销邀请码失败"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to update account"
msgstr "更新账号失败"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to update agent"
msgstr "更新 Agent 失败"

#: src/admin/pages/ChannelsPage.tsx
msgid "Force Delete"
msgstr "强制删除"

#. placeholder {0}: channel.name
#: src/admin/pages/ChannelsPage.tsx
msgid "Force delete <0>#{0}</0>? Every member loses the channel at once, and its memberships and channel-scoped grants are dropped for good. Messages are not deleted — they stay in the database, unreachable through this server. Nothing in this console brings the channel back."
msgstr "强制删除 <0>#{0}</0>？所有成员将立即失去对该频道的访问，成员关系及频道范围内的授权会永久移除。消息仍保留在数据库中，但无法通过此服务器访问。此操作无法在管理后台恢复。"

#: src/admin/pages/ChannelsPage.tsx
msgid "Force Delete Channel"
msgstr "强制删除频道"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate"
msgstr "生成"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate a signup invite code noted <0>{note}</0>? Anyone holding it can create one account on this server."
msgstr "生成备注为 <0>{note}</0> 的注册邀请码？持有此邀请码的人可以在此服务器上创建一个账号。"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate a signup invite code? Anyone holding it can create one account on this server."
msgstr "生成注册邀请码？持有此邀请码的人可以在此服务器上创建一个账号。"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate Invite Code"
msgstr "生成邀请码"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant"
msgstr "授予"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant <0><1/></0> on scope <2>{scope}</2> to <3>{0}</3>? The agent can use it from its next action on."
msgstr "向 <3>{0}</3> 授予范围为 <2>{scope}</2> 的 <0><1/></0> 权限？Agent 从下一次操作起即可使用该权限。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant Capability"
msgstr "授予权限"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Granted"
msgstr "授予时间"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Granted <0/> ({scope})"
msgstr "已授予 <0/>（{scope}）"

#: src/admin/AdminApp.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Heartbeat Lag"
msgstr "心跳滞后"

#: src/admin/messages.ts
msgid "Hermes"
msgstr "Hermes"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/SettingsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "ID"
msgstr "ID"

#: src/admin/messages.ts
msgid "Invalid API key"
msgstr "API 密钥无效"

#: src/admin/AdminApp.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Invites"
msgstr "邀请码"

#: src/admin/pages/InvitesPage.tsx
msgid "It stays usable for <0>{lifetimeHours, plural, one {# hour} other {# hours}}</0>."
msgstr "有效期为 <0>{lifetimeHours, plural, one {# 小时} other {# 小时}}</0>。"

#: src/admin/pages/InvitesPage.tsx
msgid "It stays usable until it is used or revoked."
msgstr "在使用或撤销之前一直有效。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Last Connected"
msgstr "最近连接时间"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Last Heartbeat"
msgstr "最近心跳时间"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Last Plugin"
msgstr "最近连接的插件"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Last Seen"
msgstr "最近活跃时间"

#: src/admin/LogoutButton.tsx
msgid "Log Out"
msgstr "退出登录"

#: src/admin/pages/LoginPage.tsx
#: src/admin/pages/SettingsPage.tsx
msgid "Login"
msgstr "用户名"

#: src/admin/LogoutButton.tsx
msgid "Logout"
msgstr "退出登录"

#: src/admin/messages.ts
msgid "Member"
msgstr "成员"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Members"
msgstr "成员"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Name"
msgstr "名称"

#: src/admin/messages.ts
msgid "Network unreachable"
msgstr "网络不可达"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Never"
msgstr "从未"

#: src/admin/pages/InvitesPage.tsx
msgid "Never expires"
msgstr "永不过期"

#: src/admin/pages/UserDetailPage.tsx
msgid "New Password"
msgstr "新密码"

#: src/admin/pages/UserDetailPage.tsx
msgid "No agents"
msgstr "暂无 Agent"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "No archived channels"
msgstr "暂无归档频道"

#: src/admin/pages/AgentDetailPage.tsx
msgid "No capabilities granted"
msgstr "尚未授予权限"

#: src/admin/pages/UserDetailPage.tsx
msgid "No channels"
msgstr "暂无频道"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "No data"
msgstr "暂无数据"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "No history"
msgstr "暂无变更历史"

#: src/admin/pages/InvitesPage.tsx
msgid "No invite codes"
msgstr "暂无邀请码"

#: src/admin/pages/DashboardPage.tsx
msgid "No org rows reported by /stats."
msgstr "/stats 未返回组织记录。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "No runtime registered"
msgstr "尚未注册运行时"

#: src/admin/pages/RuntimesPage.tsx
msgid "No runtimes"
msgstr "暂无运行时"

#: src/admin/pages/UsersPage.tsx
msgid "No users"
msgstr "暂无用户"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Not set"
msgstr "未设置"

#: src/admin/pages/InvitesPage.tsx
msgid "Note"
msgstr "备注"

#: src/admin/pages/DashboardPage.tsx
msgid "Online"
msgstr "在线"

#: src/admin/messages.ts
msgid "OpenClaw"
msgstr "OpenClaw"

#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "optional"
msgstr "可选"

#: src/admin/pages/DashboardPage.tsx
msgid "Organizations (debug)"
msgstr "组织（调试）"

#: src/admin/pages/DashboardPage.tsx
msgid "Orgs"
msgstr "组织"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Overwrite the password for <0>{0}</0>? The current password cannot be recovered, and their signed-in sessions end immediately."
msgstr "覆盖 <0>{0}</0> 的密码？当前密码将无法恢复，所有已登录会话会立即结束。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Owner"
msgstr "所有者"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P50"
msgstr "P50"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P95"
msgstr "P95"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P99"
msgstr "P99"

#: src/admin/pages/LoginPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Password"
msgstr "密码"

#: src/admin/pages/UserDetailPage.tsx
msgid "Password reset"
msgstr "密码已重置"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Previous Content"
msgstr "原内容"

#: src/admin/messages.ts
msgid "Private"
msgstr "私有"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Process"
msgstr "进程"

#: src/admin/messages.ts
msgid "Public"
msgstr "公开"

#: src/admin/messages.ts
msgid "Quota exceeded"
msgstr "已超出配额"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Reason"
msgstr "原因"

#. placeholder {0}: semanticLabel(i18n, snap.reason_if_at_risk)
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Reason: {0}"
msgstr "原因：{0}"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Refresh"
msgstr "刷新"

#: src/admin/messages.ts
msgid "Registered"
msgstr "已注册"

#: src/admin/pages/UserDetailPage.tsx
msgid "Reset Password"
msgstr "重置密码"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Revoke"
msgstr "撤销"

#. placeholder {0}: perm.scope
#. placeholder {1}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoke <0><1/></0> on scope <2>{0}</2> from <3>{1}</3>? The agent is denied it on its next action, and work already in flight is not interrupted. Delivery lags behind: a connected agent can still be handed message bodies it has just lost the right to read, for up to the channel-access cache lifetime (2 seconds by default)."
msgstr "撤销 <3>{1}</3> 在 <2>{0}</2> 范围内的 <0><1/></0> 权限？Agent 从下一次操作起将被拒绝使用该权限，正在执行的工作不会中断。消息投递会有延迟：已连接的 Agent 仍可能收到刚刚失去读取权限的消息正文，最长持续一个频道访问缓存周期（默认为 2 秒）。"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoke Capability"
msgstr "撤销权限"

#: src/admin/pages/InvitesPage.tsx
msgid "Revoke Invite Code"
msgstr "撤销邀请码"

#: src/admin/pages/InvitesPage.tsx
msgid "Revoke invite code <0>{code}</0>? Anyone still holding it can no longer sign up with it, and the code cannot be restored."
msgstr "撤销邀请码 <0>{code}</0>？持有此邀请码的人将无法再用它注册，且该邀请码无法恢复。"

#. placeholder {0}: perm.scope
#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoked <0/> ({0})"
msgstr "已撤销 <0/>（{0}）"

#: src/admin/pages/UserDetailPage.tsx
msgid "Role"
msgstr "角色"

#: src/admin/messages.ts
msgid "Running"
msgstr "运行中"

#. placeholder {0}: formatNumber(i18n, runtimes.length)
#: src/admin/pages/AgentDetailPage.tsx
msgid "Runtime ({0})"
msgstr "运行时（{0}）"

#: src/admin/messages.ts
msgid "Runtime crashed"
msgstr "运行时崩溃"

#: src/admin/messages.ts
msgid "Runtime timed out"
msgstr "运行时超时"

#: src/admin/AdminApp.tsx
msgid "Runtimes"
msgstr "运行时"

#. placeholder {0}: formatNumber(i18n, runtimes.length)
#: src/admin/pages/RuntimesPage.tsx
msgid "Runtimes ({0})"
msgstr "运行时（{0}）"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Sampled At"
msgstr "采样时间"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Samples"
msgstr "样本数"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Scope"
msgstr "范围"

#: src/admin/AdminApp.tsx
#: src/admin/pages/SettingsPage.tsx
msgid "Settings"
msgstr "设置"

#: src/admin/pages/LoginPage.tsx
msgid "Sign in"
msgstr "登录"

#: src/admin/pages/LoginPage.tsx
msgid "Signed out of this browser, but the server never confirmed it. That admin session may still be live."
msgstr "已在此浏览器退出登录，但服务器未确认退出。该管理员会话可能仍然有效。"

#: src/admin/pages/LoginPage.tsx
msgid "Signing in..."
msgstr "正在登录..."

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/RuntimesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Status"
msgstr "状态"

#: src/admin/messages.ts
msgid "Stopped"
msgstr "已停止"

#: src/admin/messages.ts
msgid "System"
msgstr "系统"

#: src/admin/pages/LoginPage.tsx
msgid "Technical details"
msgstr "技术详情"

#: src/admin/pages/AgentDetailPage.tsx
msgid "This server offers no way to grant this capability back"
msgstr "此服务器无法重新授予该权限"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Threshold"
msgstr "阈值"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Time"
msgstr "时间"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Token"
msgstr "权限标识"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Type"
msgstr "类型"

#: src/admin/messages.ts
msgid "Unknown ({code})"
msgstr "未知（{code}）"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Unknown capability: {grantCapability}"
msgstr "未知权限：{grantCapability}"

#: src/admin/messages.ts
msgid "Unknown reason"
msgstr "未知原因"

#: src/admin/pages/InvitesPage.tsx
msgid "Used"
msgstr "已使用"

#: src/admin/pages/UsersPage.tsx
msgid "User ID"
msgstr "用户 ID"

#: src/admin/pages/UserDetailPage.tsx
msgid "User not found"
msgstr "找不到用户"

#: src/admin/AdminApp.tsx
#: src/admin/pages/DashboardPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Users"
msgstr "用户"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "View"
msgstr "查看"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Visibility"
msgstr "可见性"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Window"
msgstr "窗口"

#: src/admin/messages.ts
msgid "Zone"
msgstr "分区"
